// Códigos de árbol: el mismo formato que valida la importación del backend
// (veracruz-cloud-service, content-bundle.factory: letras mayúsculas, números y guiones).
const TREE_CODE = /^[A-Z0-9][A-Z0-9-]{0,31}$/

// Código escrito a mano: sin espacios y en mayúsculas ("vc-0123 " → "VC-0123"); null si no
// tiene el formato.
export const normalizeTreeCode = (raw: string): string | null => {
	const code = raw.trim().toUpperCase()
	return TREE_CODE.test(code) ? code : null
}

// Lo que dice un QR leído → código del árbol, o null si no es de un árbol del Camino.
// Los QR codifican `<url de la webapp>/a/<código>`; se acepta cualquier dominio (la URL
// definitiva aún no está fijada) porque solo se usa el código para navegar dentro de la app.
export const treeCodeFromScan = (text: string): string | null => {
	const value = text.trim()
	if (!/^https?:\/\//i.test(value)) return normalizeTreeCode(value)
	try {
		const match = new URL(value).pathname.match(/^\/a\/([^/]+)\/?$/)
		return match?.[1] ? normalizeTreeCode(decodeURIComponent(match[1])) : null
	} catch {
		return null // URL o código mal formados
	}
}
